.read-only-field-wrapper{display:flex;flex-direction:column}.read-only-field-wrapper .read-only-label{font-size:14px;font-weight:300}.read-only-field-wrapper .field{font-size:14px;font-weight:400}
/*# sourceMappingURL=read-only-fields.component-42EY4OU4.css.map */
